import React from 'react';

import { EntityTable } from 'components/TeamsCommunities/EntityTable';
import { TeamEntity } from 'components/TeamsCommunities/types';
import config from 'config';
import { useCommunitiesQuery, useCommunitiesCountQuery } from 'generated/graphql';

export const TeamsList = (): JSX.Element => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const teamsQuery = useCommunitiesQuery({
    variables: {
      skip: page * rowsPerPage,
      take: rowsPerPage,
      where: { type: { equals: 'Team' } },
    } as any,
  });

  const teamsCountQuery = useCommunitiesCountQuery({
    variables: {
      where: { type: { equals: 'Team' } },
    } as any,
  });

  const teams = teamsQuery.data?.communities as TeamEntity[] | undefined;
  const teamsCount = teamsCountQuery.data?.communitiesCount;

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  return (
    <EntityTable
      entities={teams || []}
      entityTypeFromUrl="teams"
      loading={teamsQuery.loading || teamsCountQuery.loading}
      page={page}
      rowsPerPage={rowsPerPage}
      totalCount={teamsCount || 0}
      onPageChange={handlePageChange}
      onRowsPerPageChange={handleRowsPerPageChange}
      clientUrl={config.clientUrl}
    />
  );
};
